module.exports = __webpack_public_path__ + "img/director.d581ad79.jpg";